import React, { useMemo } from 'react';
import Link from 'next/link';
import { Typography, Box } from '@mui/material';
// src
import { NextImage } from '../NextImage/index';
// styles
import styles from './styles';

export interface LibCardMarketingPropertyProps {
  className?: string;
  CardHref: string;
  propertyImage: {
    image: string;
    alt?: string;
  };
  title: string;
  price: string;
  description?: string;
}

function LibCardMarketingProperty({
  className,
  CardHref,
  propertyImage,
  title,
  price,
  description
}: LibCardMarketingPropertyProps) {
  const card = useMemo(
    () => (
      <>
        <Box sx={styles.mainImgBox}>
          <NextImage
            image={{
              src: propertyImage?.image,
              alt: propertyImage?.alt || 'property-image'
            }}
            style={{ width: '100%', height: '12.625rem', objectFit: 'cover' }}
            sizes="80vw"
          />
        </Box>

        <Box sx={styles.textBox}>
          <Typography variant="h3" sx={styles.title}>
            {title}
          </Typography>
          {price && (
            <Typography variant="body1" sx={styles.price}>
              {price}
            </Typography>
          )}
          {description?.length > 0 && (
            <Typography variant="body1" sx={styles.description}>
              {description}
            </Typography>
          )}
        </Box>
      </>
    ),
    [propertyImage, title, price, description]
  );

  return (
    <Box sx={styles.cardMainBox} className={className}>
      {CardHref ? (
        <Link className="cardParent" href={CardHref}>
          {card}
        </Link>
      ) : (
        <Box className="cardParent">{card}</Box>
      )}
    </Box>
  );
}

export const CardMarketingProperty = React.memo(LibCardMarketingProperty);

export default CardMarketingProperty;
